import { useState } from "react";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { Link, useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../hooks/hooks";
import { useGetAssessmentsQuery } from "../../hooks/useGetAssessmentsQuery";
import { updateAssessment } from "../../services/school/assessment/updateAssessment";
import { key_assessments } from "../../utils/constants";
import toast from "react-hot-toast";
import { routes } from "../../routes";
import { AssessmentType } from "../../types/Assessment";
import { setAssessmentData } from "../../redux/slices/school/assessment";
import { Pencil1Icon, TrashIcon } from "@radix-ui/react-icons";
import { Lists } from "../../components/common/Lists";
import TableComponent from "../../components/common/Tables";
import { ConfirmAlertDialog } from "../../components/common/ConfirmAlertDialog";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { useGetTeacheIdByUserId } from "../../hooks/useGetTeacheIdByUserId";
import { Callout, Card, Flex, Text } from "@radix-ui/themes";
import SelectComponent from "../../components/inputs/Select/SelectComponent";
import { getTeacherClasses, getTeacherSubjects } from "../../services/school/teacher/getTeachers";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from 'yup';

const columnNamesMap: { [key: string]: string } = {
  class: 'Turma',
  subject: 'Disciplina',
  type: 'Tipo',
  weight: 'Peso',
};

const createAssessmentSchema = yup.object().shape({
  idSubject: yup.string().required('Disciplina é obrigatória'),
  idClass: yup.string().required('Turma é obrigatória'),
});
export const Assessments = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const queryClient = useQueryClient();
  const [deleteItem, setDeleteItem] = useState<AssessmentType | null>(null);
  const { UserId } = useSelector((state: RootState) => state.login.userData)
  const { data: teacherData } = useGetTeacheIdByUserId(UserId);

  const defaultValues: AssessmentType = {
    idSubject: '',
    idClass: ''
  }

  const { control, handleSubmit, setValue, getValues, formState: { errors }, watch } = useForm<AssessmentType>({
    resolver: yupResolver(createAssessmentSchema),
    defaultValues,
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    shouldUseNativeValidation: false,
  });

  const watchInputs = watch();
  const { isLoading: isLoadingClasses, refetch: fetchTeacherClasses, data: classes, isError: isErrorTeacherClasses } = useQuery(
    ['fetchTeacherClasses'],
    async () => {
      try {
        const classes = await getTeacherClasses({ PageNumber: 1, PageSize: 400, IdTeacher: teacherData?.idTeacher });
        return classes;
      } catch (error) {
      }
    },
    {
      enabled: !!teacherData?.idTeacher,
    }
  );
  const { isLoading: isLoadingSubjects, refetch: fetchTeacherSubjects, data: subjects, isError: isErrorTeacherSubjects } = useQuery(
    ['fetchTeacherSubjects'],
    async () => {
      try {
        const subjects = await getTeacherSubjects({ PageNumber: 1, PageSize: 400, IdTeacher: teacherData?.idTeacher, IdClass: getValues('idClass') });
        return subjects;
      } catch (error) {
      }
    },
    {
      enabled: false,
      refetchOnWindowFocus: false,
      retry: false
    }
  );

  const { isLoading: isLoadingAssessments, refetch: fetchTeacherAssessments, data: assessments, isError: isErrorTeacherAssessments, status } = useGetAssessmentsQuery({ PageNumber: currentPage, PageSize: 400, IdTeacher: teacherData?.idTeacher, IdClass: getValues('idClass'), IdSubject: getValues('idSubject') }, {
    enabled: !!watchInputs,
    refetchOnWindowFocus: false,
    retry: false
  });

  const mutationDelete = useMutation(updateAssessment, {
    onSuccess: () => {
      queryClient.invalidateQueries(key_assessments);
      toast.success('Configuração de avaliação apagada');
    },
    onError: () => {
      toast.error("Erro ao apagar configuração de avaliação.")
    }
  });
  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };
  const handleClickCreate = (event: any): void => {
    navigate(routes.createAssessments)
  }
  const handleEdit = (assessment: AssessmentType) => {


    // dispatch(setAssessmentData(assessment));
    //navigate(routes.updateAssessments)
  };
  const handleDelete = (assessment: AssessmentType) => {
    assessment.status = false;
    mutationDelete.mutateAsync(assessment)
  };
  const openDeleteDialog = (s: AssessmentType) => {
    setDeleteItem(s);
  };
  const confirmDelete = async () => {
    if (deleteItem) {
      await handleDelete(deleteItem!)
    }
  };


  const handleChangeClass = async (idClass: string) => {
    setValue('idClass', idClass);
    const _class = classes?.items.find(i => i.id === idClass);
    setValue("semester", _class?.semester ?? 0)
    fetchTeacherSubjects()
  };
  const handleChangeSubject = (idSubject: string) => {
    setValue('idSubject', idSubject);
    setValue('assessments', [
      {
        type: '',
        weight: 0,
        date: ''
      }]);
    fetchTeacherAssessments();
  }

  const options = assessments?.items.map(() => [
    // {
    //   label: 'Editar',
    //   onClick: (assessment: AssessmentType) => handleEdit(assessment),
    //   icon: <Pencil1Icon />
    // },
    {
      label: 'Excluir',
      onClick: (assessment: AssessmentType) => openDeleteDialog(assessment),
      icon: <TrashIcon />
    }
  ]) || [];
  if (!teacherData || !teacherData.idTeacher) {
    return (
      <Flex direction="column">
        <Callout.Root color="red" role="alert">
          <Text>
            Entre como docente &nbsp;
            <Link to={routes.dashboard} style={{ color: 'var(--gray-12)' }}>Voltar</Link>
          </Text>
        </Callout.Root>

      </Flex>
    );
  }
  return (
    <Card>
      <Flex direction='column' gap="2">
        <Card size='1'>

          <Flex gap='3'>
            <SelectComponent name="idClass" label="Turma" control={control} errors={errors} style={{ width: '100%' }}
              options={classes?.items.map(_class => {
                return {
                  label: _class.description,
                  value: _class.id ?? ""
                }
              })}
              onSelect={handleChangeClass}
              itemsLoading={isLoadingClasses}
              itemsError={isErrorTeacherClasses}
            />
            <SelectComponent name="idSubject" label="Disciplina" control={control} errors={errors} style={{ width: '100%' }}
              options={subjects?.items.map(subject => {
                return {
                  label: subject.description,
                  value: subject.id ?? ""
                }
              })}
              itemsLoading={isLoadingSubjects}
              itemsError={isErrorTeacherSubjects}
              onSelect={handleChangeSubject}
            />
          </Flex>

        </Card>
        <Lists
          status={status}
          TableComponent={() =>
            <TableComponent
              columns={Object.keys(columnNamesMap)}
              items={assessments?.items}
              options={options}
              columnNamesMap={columnNamesMap}
              totalPages={assessments?.totalPages || 1}
              currentPage={currentPage}
              onPageChange={handlePageChange}
            />
          }
          handleClickCreate={handleClickCreate}
        />
      </Flex>
      <ConfirmAlertDialog
        open={!!deleteItem}
        onOpenChange={(open) => !open && setDeleteItem(null)}
        title="Esta operação é irreversível"
        item={deleteItem}
        onConfirm={confirmDelete}
        onCancel={() => setDeleteItem(null)}
      />
    </Card>
  );
}
